module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "header": 'Edit User Email',
      "headerStyle": 'font-size: 24px; font-weight: bold',
      "max-width": '600px',
      "padding": '2em'
    }
  }, [_c('pl-input', {
    attrs: {
      "labelText": 'User Email',
      "placeholder": 'edit user email'
    },
    model: {
      value: (_vm.email_edited),
      callback: function($$v) {
        _vm.email_edited = $$v
      },
      expression: "email_edited"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n    " + _vm._s(_vm.error_message) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row mt3 center-xs"
  }, [_c('pl-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      CANCEL\n    ")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.editUserEmail.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      UPDATE EMAIL\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-07eba95c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/editUserEmailModal.vue
// module id = 2042
// module chunks = 61